import { ResponsiveTwoColumns } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';
import { FieldNames, RenderedField, SupportedSchema } from './types';

export type RenderFunction<Schema extends SupportedSchema> = (
    fields: Record<FieldNames<Schema>, RenderedField>
) => React.ReactElement;

export type RenderTemplate<Schema extends SupportedSchema> = Array<
    FieldNames<Schema> | [FieldNames<Schema>, FieldNames<Schema>]
>;

export const getFormRenderer = <Schema extends SupportedSchema>(
    renderFields?: RenderFunction<Schema> | RenderTemplate<Schema>
): RenderFunction<Schema> => {
    switch (true) {
        case typeof renderFields === 'function':
            return renderFields;
        case Array.isArray(renderFields):
            return (fields) => <TemplateRenderer fields={fields} template={renderFields} />;
        default:
            return (fields) => <OneColumnRenderer fields={fields} />;
    }
};

const OneColumnRenderer = ({ fields }: { fields: Record<string, RenderedField> }) => (
    <Stack vertical spacing="200">
        {Object.values(fields)}
    </Stack>
);

const TemplateRenderer = ({
    fields,
    template,
}: {
    fields: Record<string, RenderedField>;
    template: RenderTemplate<SupportedSchema>;
}) => (
    <Stack vertical spacing="200">
        {template.map((field) =>
            Array.isArray(field) ? (
                <ResponsiveTwoColumns key={field.toString()}>
                    {field.map((innerField) => fields[innerField])}
                </ResponsiveTwoColumns>
            ) : (
                fields[field]
            )
        )}
    </Stack>
);
